import store from '@/store'
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async index(params) {
    const res = await base.index({
      parentName: 'factory',
      parentId: store.state.app.factory.id,
      modelName: 'guideline_status',
      params,
    });
    return res;
  },
  async show(statusId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.show({
      modelName: 'guideline_status',
      modelId: statusId,
      params,
    });
    return res;
  },
  async delete(id) {
    const currentFactoryId = store.state.app.factory.id;
    const params = {
      factory: currentFactoryId
    }
    const res = await base.delete({
      modelName: 'guideline_status',
      modelId: id,
      params,
    })
    return res
  },
  async update(id, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'guideline_status',
      modelId: id,
      data: _data,
    });
    return res;
  },
}